<template>
    <div
        :class="{
            'lg:max-xl:mx-auto lg:max-xl:mt-4 lg:max-xl:grid lg:max-xl:max-w-[58.25rem] lg:max-xl:grid-cols-4 lg:max-xl:grid-rows-2 lg:max-xl:justify-items-center lg:max-xl:gap-y-5':
                isCromi(),
        }"
        class="flex justify-between">
        <NuxtLink
            v-for="(item, index) in items"
            :key="index"
            :to="item.to"
            :disabled="route.path === item.to"
            :class="
                item.to.includes('sinhroperevod') ||
                item.to.includes('dostupsreda')
                    ? 'min-w-[12.6rem]'
                    : 'max-w-[9.5rem] xl:min-w-[9.75rem] xl:max-w-[11.5rem]'
            "
            class="group/menuItem relative flex min-w-[8rem] flex-col overflow-visible bg-white text-accent-100 transition-all duration-300 hover:text-accent"
            @click="emits('close')">
            <Component
                :is="item.icon"
                class="relative z-30 mx-auto flex size-[8rem] items-center justify-center overflow-visible transition-all duration-300 xl:size-[9.75rem]" />
            <div
                v-html="item.title"
                class="text-center text-16/120 font-semibold text-ash-300 transition-all duration-300 group-hover/menuItem:text-accent max-xl:mt-4" />
            <p
                v-if="isRent()"
                class="mt-2 text-center text-12/140 font-semibold text-ash-300 transition-all duration-300 group-hover/menuItem:text-accent">
                В аренду
            </p>
            <div
                style="
                    background-image: radial-gradient(
                        circle,
                        #743fda80,
                        transparent
                    );
                "
                :class="item.to.includes('solutions') ? 'size-25' : 'size-15'"
                class="absolute inset-1/4 z-20 overflow-visible rounded-full opacity-0 blur-xl transition-all duration-300 group-hover/menuItem:opacity-100" />
        </NuxtLink>
    </div>
</template>

<script setup lang="ts">
import type { IHeaderItems } from '~/components/layouts/header/header.types'
import HeaderAllProductsIcon from '~/components/layouts/header/svg/HeaderAllProductsIcon.vue'
import HeaderAudioguidesIcon from '~/components/layouts/header/svg/HeaderAudioguidesIcon.vue'
import HeaderAvailableEnvironmentIcon from '~/components/layouts/header/svg/HeaderAvailableEnvironmentIcon.vue'
import HeaderCabinsIcon from '~/components/layouts/header/svg/HeaderCabinsIcon.vue'
import HeaderConferenceSystemsIcon from '~/components/layouts/header/svg/HeaderConferenceSystemsIcon.vue'
import HeaderRadioguidesIcon from '~/components/layouts/header/svg/HeaderRadioguidesIcon.vue'
import HeaderSolutionsIcon from '~/components/layouts/header/svg/HeaderSolutionsIcon.vue'
import HeaderTranslationEquipmentIcon from '~/components/layouts/header/svg/HeaderTranslationEquipmentIcon.vue'

defineProps({
    items: {
        type: Array as PropType<IHeaderItems[]>,
        default: () => [
            {
                title: 'Радиогиды',
                to: '/radioguide',
                icon: HeaderRadioguidesIcon,
            },
            {
                title: 'Аудиогиды',
                to: '/audioguide',
                icon: HeaderAudioguidesIcon,
            },
            {
                title: '<span class="xl:hidden">Оборудование синхронного&nbsp;перевода</span> <span class="max-xl:hidden">Оборудование синхронного&nbsp;перевода</span>',
                to: '/sinhroperevod',
                icon: HeaderTranslationEquipmentIcon,
            },
            {
                title: '<span class="max-xl:text-nowrap">Кабины <br class="max-xl:hidden" />переводчиков</span>',
                to: '/cabin',
                icon: HeaderCabinsIcon,
            },
            {
                title: '<span class="max-xl:text-nowrap">Конференц-<br class="max-xl:hidden" />системы</span>',
                to: '/conference-system',
                icon: HeaderConferenceSystemsIcon,
            },
            {
                title: 'Доступная <br class="max-xl:hidden" />среда',
                to: '/dostupsreda',
                icon: HeaderAvailableEnvironmentIcon,
            },
            {
                title: 'Все товары',
                to: '/catalog',
                icon: HeaderAllProductsIcon,
            },
            {
                title: 'Решения',
                to: '/solutions',
                icon: HeaderSolutionsIcon,
            },
        ],
    },
})

const emits = defineEmits(['close'])
const route = useRoute()
</script>
